<template>
  <div class='list'>
    <vHeader />
    <banner
      :bannerImg='juhe_bg'
      main='#fff'
      vice='#FFECC7'
      bgColor='#000'
      btnColor='#333'
      loginColor='#907D56'
     />
    <list 
      :list='listData' 
      :form='form'
      :total='total'
      @onChange='onChange'
      @handleGoClick='handleGoClick'
    />
  </div>
  
</template>

<script>
import vHeader from './header'
import banner from '@/components/headerBanner.vue'
import list from './list'
import {getSerialList} from '@/services/home'
let juhe_bg = require('../../assets/juhe_bg.png')
export default {
  components:{
    vHeader,
    list,
    banner
  },
  data(){
    return{
      listData:[],
      form:{
        pageNum: 1,
        pageSize: 8,
      },
      juhe_bg,
      total:0
    }
  },
  mounted(){
    this.getList();
  },
  methods:{
    onChange(form){
      this.form = {...form,...this.form}
      this.getList()
    },
    async getList(){
      try {
        let {data} = await getSerialList(this.form)
        this.listData = data.list;
        this.total = data.total
      } catch (error) {
        // console.log(error)
      }
    },
    handleGoClick({pageUrl}){
      window.open(pageUrl)
    }
  }
}
</script>

<style scoped>
.list{
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  padding-bottom:32px;
  box-sizing: border-box;
  background: #FFFDF7;
}
</style>